import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebCamComponent } from './web-cam.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [WebCamComponent],
  exports: [WebCamComponent]
})
export class WebCamModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/web-cam/web-cam.module.ts